// Keep this list in sync with the public routes. Redirects and unknown pages
// deliberately do not generate page views.
export const trackedPaths = new Set([
  '/about',
  '/archive',
  '/archive/good-luck-out-there',
  '/archive/truth-be-told',
  '/archive/as-the-day-burns',
  '/proposals/lapl-creators-in-residence',
  '/works/van-dyke',
  '/works/cheap-patriot',
  '/works/heavy-industry',
  '/works/bricking-my-phone',
  '/works/magnolia-flower',
]);

export const exclusionCookie = 'analytics_excluded';
export const sessionLifetime = 30 * 60 * 1000;
export const visitorLifetime = 365 * 24 * 60 * 60 * 1000;
export const uuidPattern =
  /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export type PageView = {
  id: string;
  visitorId: string;
  sessionId: string;
  path: string;
  previousPath: string | null;
};

export function parsePageView(value: unknown): PageView | null {
  if (!value || typeof value !== 'object') return null;
  const data = value as Record<string, unknown>;
  if (
    ![data.id, data.visitorId, data.sessionId].every(
      (id) => typeof id === 'string' && uuidPattern.test(id),
    ) ||
    typeof data.path !== 'string' ||
    !trackedPaths.has(data.path) ||
    (data.previousPath !== null &&
      (typeof data.previousPath !== 'string' ||
        !trackedPaths.has(data.previousPath)))
  ) {
    return null;
  }
  return {
    id: data.id as string,
    visitorId: data.visitorId as string,
    sessionId: data.sessionId as string,
    path: data.path,
    previousPath: data.previousPath as string | null,
  };
}
